const Role = {
    role1: "manager",
}

export default Role;